import { render, staticRenderFns } from "./email_field.vue?vue&type=template&id=1b5c4043&"
import script from "./email_field.vue?vue&type=script&lang=js&"
export * from "./email_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5c4043')) {
      api.createRecord('1b5c4043', component.options)
    } else {
      api.reload('1b5c4043', component.options)
    }
    module.hot.accept("./email_field.vue?vue&type=template&id=1b5c4043&", function () {
      api.rerender('1b5c4043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/email_field.vue"
export default component.exports